/* ============================================================
   ROCKET FUEL — NEW DESIGN shared behaviors (Claude build)
   Reveal-on-scroll, word-by-word headings, parallax/zoom,
   magnetic buttons. All guarded for reduced motion.
   ============================================================ */
(function () {
  'use strict';
  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function init() {
    /* ---- word-by-word headings ---- */
    document.querySelectorAll('.rf-h2:not([data-rf-split])').forEach(function (h) {
      h.setAttribute('data-rf-split', '1');
      var hl = (h.getAttribute('data-hl') || '').toLowerCase().split(/\s+/).filter(Boolean).map(function (t) { return t.replace(/[^\w'&-]/g, ''); });
      var words = h.textContent.trim().split(/\s+/);
      h.textContent = '';
      words.forEach(function (w, i) {
        var s = document.createElement('span');
        s.className = 'rf-w';
        if (hl.indexOf(w.toLowerCase().replace(/[^\w'&-]/g, '')) !== -1) s.className += ' rf-w-hl';
        s.textContent = w;
        s.style.transitionDelay = (i * 55) + 'ms';
        h.appendChild(s);
        h.appendChild(document.createTextNode(' '));
      });
    });

    /* ---- reveal on scroll ---- */
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('rf-in'); io.unobserve(e.target); }
      });
    }, { threshold: 0.12 });
    document.querySelectorAll('.rf-rv').forEach(function (el) { io.observe(el); });

    var hio = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('rf-in'); hio.unobserve(e.target); }
      });
    }, { threshold: 0.5 });
    document.querySelectorAll('.rf-h2').forEach(function (h) { hio.observe(h); });

    /* ---- scroll-driven parallax + zoom ---- */
    if (!reduced) {
      var plx = [].slice.call(document.querySelectorAll('[data-rf-plx]')).map(function (el) {
        return { el: el, k: parseFloat(el.getAttribute('data-rf-plx')) || 0 };
      });
      var zooms = [].slice.call(document.querySelectorAll('[data-rf-zoom]')).map(function (el) {
        return { el: el, k: parseFloat(el.getAttribute('data-rf-zoom')) || 0.1 };
      });
      if (plx.length || zooms.length) {
        var mob = window.innerWidth < 720 ? 0.6 : 1;
        var ticking = false;
        var apply = function () {
          ticking = false;
          var vh = window.innerHeight;
          plx.forEach(function (it) {
            if (!it.el.isConnected) return;
            var r = it.el.getBoundingClientRect();
            if (r.bottom < -160 || r.top > vh + 160) return;
            var c = (r.top + r.height / 2 - vh / 2) / vh;
            it.el.style.translate = '0 ' + (c * it.k * 220 * mob).toFixed(1) + 'px';
          });
          zooms.forEach(function (it) {
            var host = it.el.parentElement;
            if (!host || !it.el.isConnected) return;
            var r = host.getBoundingClientRect();
            if (r.bottom < 0 || r.top > vh) return;
            var q = Math.min(1, Math.max(0, 1 - Math.abs((r.top + r.height / 2 - vh / 2) / vh)));
            it.el.style.scale = (1 + q * it.k).toFixed(4);
          });
        };
        var onScroll = function () {
          if (!ticking) { ticking = true; requestAnimationFrame(apply); }
        };
        window.addEventListener('scroll', onScroll, { passive: true });
        window.addEventListener('resize', onScroll);
        apply();
      }
    }

    /* ---- magnetic primary buttons ---- */
    if (!reduced && window.matchMedia('(pointer:fine)').matches) {
      document.querySelectorAll('.rf-btn-primary').forEach(function (btn) {
        btn.addEventListener('mousemove', function (e) {
          var r = btn.getBoundingClientRect();
          btn.style.setProperty('--rf-bx', ((e.clientX - r.left) / r.width - 0.5) * 10 + 'px');
          btn.style.setProperty('--rf-by', ((e.clientY - r.top) / r.height - 0.5) * 6 + 'px');
        });
        btn.addEventListener('mouseleave', function () {
          btn.style.setProperty('--rf-bx', '0px');
          btn.style.setProperty('--rf-by', '0px');
        });
      });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  /* re-init on Shopify section reload in the theme editor */
  document.addEventListener('shopify:section:load', init);
})();
